module.exports = __webpack_public_path__ + "static/img/image038.d90b797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image038.png
// module id = 5Q+8
// module chunks = 1